import { render, staticRenderFns } from "./InventoryDisposal.vue?vue&type=template&id=309ef608&"
import script from "./InventoryDisposal.vue?vue&type=script&lang=js&"
export * from "./InventoryDisposal.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDisposal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports